import { configureTableColumns } from 'utils/table-helpers';

import { useGetAccountsQuery } from 'features/account/services';
import { FETCH_ALL_PARAMS } from 'constants/query';
import { APP_ROLES } from 'constants/app-roles';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { useMemo } from 'react';
import { useGetCompaniesQuery } from 'features/company/services';
import useTable from 'hooks/useTable';
import { CompanyOwnersColumns, useCompanyOwnerTableColumns } from '../constants/company-owners-table-settings';

export const useController = () => {
    const role = APP_ROLES.COMPANY_OWNER;
    const { data: accounts } = useGetAccountsQuery({ ...FETCH_ALL_PARAMS, role_id: role });
    const { data: companies } = useGetCompaniesQuery(FETCH_ALL_PARAMS);
    const filterSelectOptions = useMemo(() => {
        if (!accounts) return;

        return {
            email: accounts.content.map((account) => {
                return {
                    value: account.email,
                    label: account.email,
                };
            }),
            companyName: mapToSelectOptions(companies?.content),
        };
    }, [accounts, companies]);

    const { tableSettings } = useTable<CompanyOwnersColumns>({
        columns: configureTableColumns(useCompanyOwnerTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'companyOwners',
    });

    return {
        tableSettings,
    };
};

export default useController;
